import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';

/**
 * Firebase Web App Configuration
 *
 * IMPORTANT: The credentials provided were Admin SDK credentials (server-side only).
 * For client-side React authentication, you need the Firebase Web App config.
 *
 * Get your Firebase Web App config from:
 * Firebase Console > Project Settings > Your apps > Web app
 *
 * Required environment variables:
 * - VITE_FIREBASE_API_KEY
 * - VITE_FIREBASE_AUTH_DOMAIN (defaults to {projectId}.firebaseapp.com)
 * - VITE_FIREBASE_PROJECT_ID (you provided: zhopingo)
 * - VITE_FIREBASE_STORAGE_BUCKET (you provided: zhopingo.firebasestorage.app)
 * - VITE_FIREBASE_MESSAGING_SENDER_ID
 * - VITE_FIREBASE_APP_ID
 */

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
  authDomain:
    import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ||
    `${import.meta.env.VITE_FIREBASE_PROJECT_ID || 'zhopingo'}.firebaseapp.com`,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'zhopingo',
  storageBucket:
    import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ||
    'zhopingo.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '',
};

// Initialize Firebase
let firebaseApp: FirebaseApp;
if (getApps().length === 0) {
  firebaseApp = initializeApp(firebaseConfig);
} else {
  firebaseApp = getApps()[0];
}

// Initialize Firebase Authentication and get a reference to the service
export const auth: Auth = getAuth(firebaseApp);

export default firebaseApp;
